import { render, staticRenderFns } from "./ReturnHistoryPage.vue?vue&type=template&id=baa490ee&scoped=true&"
import script from "./ReturnHistoryPage.vue?vue&type=script&lang=js&"
export * from "./ReturnHistoryPage.vue?vue&type=script&lang=js&"
import style0 from "./ReturnHistoryPage.vue?vue&type=style&index=0&id=baa490ee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "baa490ee",
  null
  
)

export default component.exports